interface DeleteRepository {
  delete(distributorId: number, discountId: string, deleteMetaDiscount: boolean): Promise<void>
}

export class DeleteDiscount {
  constructor(private readonly repository: DeleteRepository) {}

  async execute(distributorId: number, discountId: string, deleteMetaDiscount: boolean) {
    return this.repository.delete(distributorId, discountId, deleteMetaDiscount)
  }
}
